import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tabs, BackTop } from 'antd';
import Dashboard from './Dashboard';
import DimensionAnalysis from '../DimensionAnalysis';

const { TabPane } = Tabs;

class ProjectIndicatorAnalysis extends Component {
    static childContextTypes = {
        moduleType: PropTypes.string,
        activeKey: PropTypes.string,
        business: PropTypes.array,
        contractType: PropTypes.array,
        systemDate: PropTypes.object,
        handleExpand: PropTypes.func,
        isSeniorUserBo: PropTypes.bool,
        FINANCE_INDICATOR_ANALYSIS: PropTypes.bool,
        isDesignatedTal: PropTypes.bool,
        isLineCharge: PropTypes.bool,
    }

    constructor(props) {
        super(props);
        this.panes = [{
            title: '财务收入分析',
            key: 'financeIncome',
        }, {
            title: '中心收入分析',
            key: 'centerIncome',
        }, {
            title: '请款分析',
            key: 'request',
        }];
        this.state = {
            activeKey: 'financeIncome',
            moduleType: '',
        };
    }

    getChildContext = () => {
        const { business, contractType, systemDate, isSeniorUserBo, FINANCE_INDICATOR_ANALYSIS, isDesignatedTal, isLineCharge } = this.props;
        const { moduleType, activeKey } = this.state;
          // 中心收入分析 筛选需要过滤掉 ARO & 招募
        const newBusiness = activeKey == 'centerIncome' ? (business || []).filter(item=>item.typeValue != 'ARO' && item.typeValue != '招募') : business;
        return {
            moduleType,
            activeKey,
            business:newBusiness,
            contractType,
            systemDate,
            handleExpand: this.handleExpand,
            isSeniorUserBo,
            FINANCE_INDICATOR_ANALYSIS,
            isDesignatedTal,
            isLineCharge,
        };
    }

    handleExpand = (moduleType) => {
        this.setState({ moduleType });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey });
    }

    getContent = (pane) => {
        const { activeKey } = this.state;
        if (pane.key === activeKey) {
            return (
                <Dashboard/>
            );
        } else {
            return null;
        }
    }

    render() {
        const { activeKey, moduleType } = this.state;
        const{financeIndicatorAnalysis,projectIndicatorAnalysis}=this.props;
        return (
            <div className="tabWidth homePageTab" style={{ marginTop: -16 }}>
                {
                    !moduleType ?
                        <Tabs activeKey={activeKey} onChange={this.handleTabsChange}>
                            {this.panes.map(pane => <TabPane tab={pane.title} key={pane.key} disabled={pane.disabled}>{this.getContent(pane)}</TabPane>)}
                        </Tabs>
                    :
                        <DimensionAnalysis source="finance" 
                        financeIndicatorAnalysis={financeIndicatorAnalysis} 
                        projectIndicatorAnalysis={projectIndicatorAnalysis}
                        />
                }
                <BackTop />
            </div>
        );
    }
}

export default ProjectIndicatorAnalysis;


// WEBPACK FOOTER //
// ./src/components/homePage/FinanceIndicatorAnalysis/index.js